import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'payment-method-selector-popup:title-text': {
    id: 'payment-method-selector-popup:title-text',
    defaultMessage: 'Paying With',
    description: 'Paying With options list title text',
  },
});
